import type { FC } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
    markClassName?: string
}

/** FORQ mark: an F whose arms are cut like fork tines, beside the wordmark. */
export const Logo: FC<LogoProps> = ({ className, markClassName }) => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <svg viewBox='0 0 32 32' className={cn('size-8 shrink-0', markClassName)} aria-hidden='true'>
                <rect width='32' height='32' rx='8' className='fill-brand' />
                <path d='M8.5 6.5h5v19h-5z' fill='#111214' />
                <path d='M13.5 6.5h11l-2.2 4.5h-8.8z' fill='#111214' />
                <path d='M13.5 14h8l-2 4.2h-6z' fill='#111214' />
            </svg>

            <span className='font-heading font-expanded text-lg font-extrabold tracking-tight text-foreground'>
                FORQ
            </span>
        </span>
    )
}
